import { FunctionComponent } from 'react';
import { PuffLoader, ScaleLoader } from 'react-spinners';
import { useTheme } from 'styled-components';
import { SpinnerProps } from './types';

export const Spinner: FunctionComponent<SpinnerProps> = props => {
  const { type } = props;

  // Retrieve application theme
  const theme = useTheme();

  switch (type) {
    case 'scale':
      return (
        <ScaleLoader
          color={theme.brand.main}
          margin={2}
          height={30}
          radius={10}
          width={3}
          speedMultiplier={1.2}
        />
      );
    case 'puff':
    default:
      return <PuffLoader color={theme.brand.main} size={30} speedMultiplier={1.2} />;
  }
};
